import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { AchievementService } from 'src/app/services/achievement.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { JournalService } from 'src/app/services/journal.service';
import { UserEatWellService } from 'src/app/services/user-eat-well.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-i-quit-index',
  templateUrl: './i-quit-index.component.html',
  styleUrls: ['./i-quit-index.component.scss'],
})
export class IQuitIndexComponent implements OnInit {
  isLoading = false;
  userData: any;
  allEntries: any;
  eatWellWeekData: any;
  weekScore = 0;
  allTaskStatuses: any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();

  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    private userEatWellService: UserEatWellService,
    private userTaskStatusService: UserTaskStatusService,
    public journalService: JournalService,
    private achievementService: AchievementService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.achievementService.refreshNotifications();
        this.isLoading = false;
      }
    });

    forkJoin({
      allEntries: this.userEatWellService.fetchAll(),
      allUserTaskStatuses: this.userTaskStatusService.fetchAll(),
    }).subscribe(
      (responseData) => {
        this.allEntries = responseData.allEntries;

        this.eatWellWeekData = this.userEatWellService.generateWeekArray(
          this.currentWeek,
          this.allEntries
        );

        this.weekScore = this.userEatWellService.getWeekScore(
          this.eatWellWeekData
        );

        this.isLoading = false;

        this.allTaskStatuses = responseData.allUserTaskStatuses;
        let readResources = this.userTaskStatusService.checkTaskStatus(
          this.allTaskStatuses,
          'IQuitIntro'
        );
        if (!readResources) {
          this.router.navigate(['/modules', 'i-quit', 'resources']);
        }

        // do we need to ask about a referral?
        let askRefer = this.userTaskStatusService.checkTaskStatus(
          this.allTaskStatuses,
          'askIQuitRefer'
        );
        if (askRefer) {
          Swal.fire({
            //title: "Are you sure?",
            text: 'Would you be interested in a referral to your local smoking cessation support?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
          }).then((result) => {
            this.userTaskStatusService
              .create('askIQuitRefer', '1')
              .subscribe((responseData) => {
                if (result.value) {
                  // TODO REFER THE PATIENT
                  Swal.fire({
                    text: "That's great - we've let your support service know. Now it's time to have a look at our i-Quit",
                    icon: 'success',
                    confirmButtonText: 'Start I-Quit',
                  });
                } else {
                  Swal.fire({
                    text: "That's fine -  we're here if you change your mind.  Now it's time to have a look at our i-Quit",
                    icon: 'success',
                    confirmButtonText: 'Start I-Quit',
                  });
                }
              });
          });
        }
      },
      (error) => {}
    );
  }
}
